export enum FinancialMetricTypesEnum {
  BASE_FEE = 'BASE_FEE', // fee for txs greater than TRANSACTION_USD_BOUND in %
  FOLLOWINGS_BUYS_FEE = 'FOLLOWINGS_BUYS_FEE', // in %
  TOKEN_CREATOR_FEE = 'TOKEN_CREATOR_FEE', // in %
  TRANSACTION_USD_BOUND = 'TRANSACTION_USD_BOUND', // in USD
  LOW_BASE_FEE_USD = 'LOW_BASE_FEE_USD', //fee for txs greater than TRANSACTION_USD_BOUND  in USD
  CROWDFUNDING_USD_BOUND = 'CROWDFUNDING_USD_BOUND', //after crossing this value token will be deployed
}


export type FinancialMetrics = {
  id: string;
  type: FinancialMetricTypesEnum;
  value: number;
  createdAt: Date;
  updatedAt: Date;
};
